<template>
  <v-card class="pa-4" style="margin-top: 50px;">
    <v-card-title class="d-flex align-center mt-2 mb-2">
      <v-icon class="mr-2">mdi-map-marker</v-icon>
      <h3 class="mb-0">
        <strong>Puesto de Empaquetado</strong>
      </h3>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field ref="locationInput" v-model="scannedLocation" label="Código de ubicación" density="comfortable"
            :loading="loading" @keyup.enter="handleScan" autofocus clearable class="mt-4"
            >
            <template #prepend-inner>
              <v-icon>mdi-map-marker</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-alert color="#D0EBFF">
        <p class="mb-0 text-caption" style="font-size: 1rem;">
          Para comenzar el empaquetado necesitas definir tu ubicación actual
        </p>
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ScanLocation",
  data() {
    return {
      scannedLocation: "",
      loading: false,
      hasError: false,
      errorMessage: ""
    };
  },
  emits: ['location-scanned', 'error'],
  mounted() {
    this.focusInput();
  },
  methods: {
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.locationInput) {
          this.$refs.locationInput.focus();
        }
      });
    },

    clearError() {
      this.hasError = false;
      this.errorMessage = "";
    },

    handleScan() {
      if (!this.scannedLocation || this.scannedLocation.trim() === "") {
        this.showError("Por favor ingresa un código de ubicación");
        return;
      }

      this.loading = true;
      this.clearError();

      this.$emit('location-scanned', this.scannedLocation.trim());
    },

    showError(message) {
      this.hasError = true;
      this.errorMessage = message;
      this.loading = false;
      this.focusInput();
    },

    reset() {
      this.scannedLocation = "";
      this.loading = false;
      this.clearError();
      this.focusInput();
    }
  }
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}

.bg-primary {
  background-color: #1976D2 !important;
}
</style>
